import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let commodityOptions = [];
function CompanyProductTableRow({ index, commodityList, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [commodityKey, setCommodityKey] = useState(0);
	const [commoditySelected, setCommoditySelected] = useState({ name: "commodityKey", label: "", value: 0 });
	const [commodityLoaded, setCommodityLoaded] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);
	const [productName, setProductName] = useState("");
	const [productSku, setProductSku] = useState("");
	const [description, setDescription] = useState("");
	const productNameRef = useRef(null);
	const productSkuRef = useRef(null);
	const descriptionRef = useRef(null);

	useEffect(() => {
		setCommodityValues(commodityList);
	}, []);
	function setCommodityValues(commodityObj) {
		let commodityValue = {};
		commodityOptions = [];
		commodityOptions.push({ label: "", value: 0 });
		if (commodityObj && commodityObj.length > 0) {
			commodityObj.map((aCommodity) => {
				commodityValue.label = aCommodity.commodityName;
				commodityValue.value = aCommodity.commodityKey;
				commodityOptions.push(commodityValue);
				commodityValue = {};
			});
		}
		setCommodityLoaded(true);
		setCommoditySelected({ ...commoditySelected, label: "", value: 0 });
	}

	const commodityHandler = (selectedOption, action) => {
		let selectedCommodityKey = selectedOption ? selectedOption.value : 0;
		let selectedCommodityName = selectedOption ? selectedOption.label : "";
		setCommodityKey(selectedCommodityKey);
		setCommoditySelected({ ...commoditySelected, label: selectedCommodityName, value: selectedCommodityKey });
	}

	function productNameHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedProductName = e.target.value;
		setProductName(selectedProductName);
	}
	function productSkuHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedProductSku = e.target.value;
		setProductSku(selectedProductSku);
	}

	function descriptionHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedDescription = e.target.value;
		setDescription(selectedDescription);
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let productNameSet = productNameRef.current.value || "";
		let descSet = descriptionRef.current.value || "";
		let productSkuSet = productSkuRef.current.value || "";

		if (!commodityKey || commodityKey === 0) {
			setError(t("error.commoName.Reqd"));
			setIsSubmit(false);
		} else if ((typeof productNameSet === 'undefined') || !productNameSet || !productNameSet.trim()) {
			setError(t("error.prodName.Reqd"));
			setIsSubmit(false);
		} else {
			let initialValues = {
				commodityKey: commodityKey,
				productName: productNameSet.trim(),
				productSku: productSkuSet.trim(),
				description: descSet.trim(),
			};
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{commodityLoaded ? <Select
					name="commodityKey"
					options={commodityOptions}
					onChange={commodityHandler}
					placeholder={""}
					value={commoditySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="commodityKey-input"
					styles={ddStyles}
				/>
					: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="text"
					name="productName"
					id="productName"
					value={productName}
					maxLength="50"
					className="form-control rounded-pill shadow-sm px-4 "
					ref={productNameRef}
					onChange={(e) => (productNameHandler(e))}
					style={{ maxWidth: "15vw" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="text"
					name="productSku"
					id="productSku"
					value={productSku}
					maxLength="70"
					className="form-control rounded-pill shadow-sm px-4 "
					ref={productSkuRef}
					onChange={(e) => (productSkuHandler(e))}
					style={{ maxWidth: "15vw" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="text"
					name="description"
					id="description"
					value={description}
					maxLength="70"
					className="form-control rounded-pill shadow-sm px-4 "
					ref={descriptionRef}
					onChange={(e) => (descriptionHandler(e))}
					style={{ maxWidth: "15vw" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default CompanyProductTableRow;